export default {
  data() {
    return {
      estadosLocacao: [
        {
          id: "aberto",
          nome: "Aberto",
          cor: "grey"
        },
        {
          id: "fechado",
          nome: "Fechado",
          cor: "green"
        },
        {
          id: "cancelado",
          nome: "Cancelado",
          cor: "red"
        },
        {
          id: "aprovacao",
          nome: "Pendente aprovação",
          cor: "orange"
        },
        {
          id: "reprovado",
          nome: "Reprovado",
          cor: "red"
        }
      ]
    };
  },

  methods: {
    buscarStatusLocacaoPorId(id) {
      return this.estadosLocacao.find(estado => estado.id === id);
    }
  }
};
